import { createSlice } from '@reduxjs/toolkit';

type InitialState = {
	lastCourseParams: {
		way: string;
		status: string;
	};
};

const initialState: InitialState = {
	lastCourseParams: {
		way: '',
		status: '',
	},
};

const urlReducer = createSlice({
	name: 'modals',
	initialState,
	reducers: {
		setLastCourseParams: (state, action) => {
			state.lastCourseParams = action.payload;
		},
	},
});

export const { setLastCourseParams } = urlReducer.actions;
export default urlReducer;
